;; TODO: Move some stuff from the bcc.networking NS to here - or perhaps the other way around.
(ns bec-cljs-common.state-sync-client
  (:require [editscript.core :as editscript]
            [taoensso.timbre :as log]
            [re-frame.core :as rf]
            [ajax.core :as ajax]
            [bec-data-format.core :as bec-df]
            [bec-cljs-common.config :as config]
            [bec-cljs-common.networking :as net]))


(defn patch!
  ([new-state old-state]
   (patch! new-state old-state {}))

  ([new-state old-state m]
   (let [edits (-> (editscript/diff (get-in old-state (or (:client-state-path m) config/client-state-path))
                                    (get-in new-state (or (:client-state-path m) config/client-state-path))
                                    (if (net/local?)
                                      {:str-diff? false, :algo :quick}
                                      {:str-diff? true, :algo :a-star}))
                   (editscript.edit/get-edits))]
     (when (not= edits [])
       (let [handler (fn [res]
                       (when-not (= 201 (:status res))
                         (throw (ex-info "patch! got server error" res))))] ;; TODO: Use some standard error UI dialog thing here?
         (ajax/POST (or (:url m) (str config/app-server-url (net/sse-url (or (:stream-name m) config/stream-name)
                                                                         config/viewport-id "patch")))
                    {:params {:edits edits}
                     :format (bec-df/cljs-ajax-request-format)
                     :response-format (ajax/ring-response-format)
                     :handler handler
                     :error-handler #(-> % :response handler)}))))
   nil))


(rf/reg-fx ::patch!
  (fn [[new-db old-db]]
    (patch! new-db old-db)))

(rf/reg-event-fx ::patch!
  (fn [{:keys [db]} [_ update-db-fn props]]
    (let [new-db (update-db-fn db props)]
      {:fx [[::patch! [new-db db]]]})))
